// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#bespoke-email-listener-title[data-v-3034a887]{max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.bespoke-email-text[data-v-3034a887] textarea{padding-bottom:12px;white-space:pre-line}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
